import { lazy, Suspense, type ReactNode } from 'react';
import { Outlet } from 'react-router';
import { PopUp } from './components/PopUp/PopUp';
import { isMockAuthEnabled } from './app/mockAuth';
import { lazyNamed } from './app/lazyNamed';
import { ErrorBoundary, FullPageLoader } from '@/shared/ui';
import './App.css';

/**
 * Production path: loads MsalProvider + PageLayout + LoginPage lazily.
 * vendor-msal (~480 kB) stays out of the initial bundle.
 */
const AuthGate = lazyNamed(() => import('./app/AuthGate'), 'AuthGate');

/**
 * Mock-auth / E2E path: loads PageLayout without touching @azure/msal-*.
 * Wraps children so <Outlet /> renders inside the normal app shell.
 */
const MockPageLayout = lazy(() =>
  import('./components/PageLayout/PageLayout').then((m) => ({
    default: ({ children }: { children: ReactNode }) => (
      <m.PageLayout>{children}</m.PageLayout>
    ),
  }))
);

export function App() {
  const mockAuth = isMockAuthEnabled();

  return (
    <div className="App">
      <Suspense fallback={<FullPageLoader />}>
        {mockAuth ? (
          <MockPageLayout>
            <ErrorBoundary>
              <Outlet />
            </ErrorBoundary>
          </MockPageLayout>
        ) : (
          <AuthGate />
        )}
      </Suspense>
      <PopUp />
    </div>
  );
}
